import importerStore from '@/shared/importer/importer-store';
import { ReservationService } from '@/modules/reservation/reservation-service';
import reservationImporterFields from '@/modules/reservation/reservation-importer-fields';
import { i18n } from '@/i18n';

export default importerStore(
  ReservationService.import,
  reservationImporterFields,
  i18n('entities.reservation.importer.fileName'),
  i18n('entities.reservation.importer.hint'),
);
